import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { getCookie } from "../utils/Common";
import { Roles } from "../utils/enums";

const Redirect = () => {
  const navigate = useNavigate();
  useEffect(() => {
    // Loan officers still land on the create/evaluate flow — every other
    // role (processor, underwriter, credit committee, ...) lands on the
    // loan list instead.
    const userPermissions = JSON.parse(getCookie("userPermissions") || "[]");
    const isLoanOfficer = userPermissions?.includes(Roles.loanOfficer);
    navigate(isLoanOfficer ? "/evaluate-loan" : "/list-view");
  }, [])

  return null;
}

export default Redirect;
